(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alp-abandoned-checkout-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.alp-abandoned-checkout-popup');
    if (!popup) return;

    // 判断当前页面是否为特殊活动页
    const disabled = popup.dataset.disabled === 'true';

    // 1. 页面加载时检查是否有 abandoned checkout 记录且不是在活动页, 如果都是的话就正常弹窗
    // 也就是普通页面进入结账页后,要去到非活动页才会出现弹窗,也就是活动页不出现弹窗,其他页面才会出现弹窗
    if (document.cookie.includes('alp_abandoned_checkout_triggered=true') && !disabled) {
      // Popup 真正触发后再清除 abandoned checkout
      if (popupOpen()) {
        document.cookie = 'alp_abandoned_checkout_triggered=false; path=/; max-age=0';
      }
    }

    // 2. 监听 Checkout / Payment 按钮
    const triggerButtons = document.querySelectorAll(`[type="submit"]#checkout, .alp-payment-button-wrapper`);
    triggerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (disabled) {
          // 特殊活动页发起 Checkout：不产生 abandoned checkout，同时清除旧记录
          // 结果就是活动页进入结账页后返回活动页或者是去到其他页面, 都不会出现弹窗
          document.cookie = 'alp_abandoned_checkout_triggered=false; path=/; max-age=0';
        } else {
          // 普通页面发起 Checkout：记录 abandoned checkout
          document.cookie = 'alp_abandoned_checkout_triggered=true; path=/; max-age=86400';
        }
      });
    });

    // 3. 打开 Klaviyo Popup
    function popupOpen() {
      const popupId = popup.dataset.id;
      const delay = parseInt(popup.dataset.delay, 10) || 0;

      if (popupId) {
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', popupId]);
          console.log('Abandoned checkout popup opened');
        }, delay);
      }

      return true
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-article-custom-faqs-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    $('.alp-article-custom-faqs-item-list-item-title').click(function () {
      let $this = $(this).parent();
      $this.toggleClass('active');
      $this.siblings().removeClass('active');
      $this.find('.alp-article-custom-faqs-item-list-item-answer').stop().slideToggle(400);
      $this.siblings().find('.alp-article-custom-faqs-item-list-item-answer').stop().slideUp(400);
    });

    const $firstItem = $('.alp-article-custom-faqs-item-list-item').first();
    $firstItem.addClass('active');
    $firstItem.find('.alp-article-custom-faqs-item-list-item-answer').show();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-buy-buttons-bv"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function buyNowTrigger() {
      let $fn = AlpFn;
      let $el = $('.alp_product__custom_buy_now');
      let $cartEl = '[data-ajax-cart]';
      let $parent = 'form';
      $el.on('click', async function (e) {
        e.preventDefault();
        let $this = $(`.alp-submit-button [type="submit"]`).parents($parent);
        $this.addClass('ajaxForm loading');
        $(`[data-trigger-add-to-cart]`).addClass('loading');

        let addToCartForm = $this[0];
        let formData = new FormData(addToCartForm);
        await fetch(Shopify_Url + 'cart/clear.js', {
          method: 'POST',
        });
        await $fn.AdditionalProductsAddCart();
        let $response = await fetch(Shopify_Url + 'cart/add.js', {
          method: 'POST',
          body: formData,
        });
        if ($response.status == 200) {
          console.log(`Product Added To Cart`);
          // await $fn.refreshCart($cartEl);
          $this.removeClass('loading');
          $(`[data-trigger-add-to-cart]`).removeClass('loading');
          $(`button#checkout[name="checkout"]`).trigger('click');
        }
      });
    }
    buyNowTrigger();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-header-search-recommends"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    let el = document.querySelectorAll('.search-modal__recommend');
    el.forEach((item, index) => {
      let id = item.dataset.id;
      let itemEl = document.querySelector(`.search-modal__recommend-swiper[data-id="${id}"]`);
      let swiper = new Swiper(itemEl, {
        direction: 'vertical',
        loop: true,
        autoplay: {
          delay: 4000,
        },
        slidesPerView: 1,
      });
      // when button.search__button click, input value set actived slide's text without <b>, .search__button has same parent with input and .search-modal__recommend
      let search_parent = item.parentElement;
      let searchButton = search_parent.querySelector('.search__button');
      searchButton.addEventListener('click', function () {
        let input = search_parent.querySelector('input.search__input');
        // if input value is empty
        if (!input.value) {
          input.value = itemEl.querySelector('.swiper-slide-active .search-modal__recommend-item-text').dataset.value;
          input.focus();
          item.classList.add('opacity-0');
        }
      });
      // when input has value, set .search-modal__recommend opacity 0
      let input = search_parent.querySelector('input.search__input');
      function checkInputValue() {
        if (input.value) {
          item.classList.add('opacity-0');
        } else {
          item.classList.remove('opacity-0');
        }
      }
      input.addEventListener('input', checkInputValue);
      checkInputValue();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-product-promotion-new-2-item-2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function setHeightLimit() {
      let el = $('.alp-combo-sale-select-additional-products-item');
      el.each(function () {
        let $this = $(this);
        let $show_more = $this.find('.promotion-new-item-2-show-more');
        if ($show_more.length > 0) {
          $this.addClass('has-show-more');
          let $maxHeight =
            $this.find('.promotion-new-item-list-a-i-flex').eq(0).outerHeight() +
            $this.find('.alp-product-promotion-new-2-i-title-2').outerHeight() +
            50;
          $this.css('--max-height', $maxHeight);
        } else {
          $this.parents('.alp-combo-sale-select-additional-products').css('--initial-max-height', $this.outerHeight());
        }
      });
    }
    setInterval(() => {
      setHeightLimit();
    }, 1000);
    $('.promotion-new-item-2-show-more').on('click', function () {
      let $this = $(this);
      $this.parents('.alp-combo-sale-select-additional-products-item').toggleClass('open');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-product-promotion-new-2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    $(
      `.alp-product-promotion-new-2-item .promotion-new-item-list-a-i-flex-text , .alp-product-promotion-new-2-item > .alp-product-promotion-new-2-i-title > div:first-child`
    ).on('click', function () {
      let $this = $(this).parents('.alp-product-promotion-new-2-item');
      if ($this.parent().hasClass('single-slect')) {
        if ($this.hasClass('selected')) {
        } else {
          $this.addClass('selected').siblings().removeClass('selected');
        }
      } else {
        $this.toggleClass('selected');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-sub-zk-mega-menu-1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    $('.sub-mega-menu-zk-1-inner-1-title-i').click(function () {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      const index = $(this).index();
      $(this)
        .closest('.sub-mega-menu-zk-1-inner-1')
        .find('.sub-mega-menu-zk-1-inner-1-items > div')
        .eq(index)
        .addClass('active')
        .siblings()
        .removeClass('active');
    });
    $('.sub-mega-menu-zk-1-inner-1').each(function () {
      $(this).find('.sub-mega-menu-zk-1-inner-1-title-i').eq(0).addClass('active');
      $(this).find('.sub-mega-menu-zk-1-inner-1-items > div').eq(0).addClass('active').siblings().removeClass('active');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-discount-code-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#axx-discount-form');
    const input = form.querySelector('.axx-discount-code');
    const messageEl = form.querySelector('.axx-discount-message');
    const appliedContainer = form.querySelector('.axx-applied-discounts');
    const summaryContainer = document.querySelector('.axx-ajax-cart-discount-summary');

    if (!form || !input || !messageEl || !appliedContainer) return;

    // --- Helpers -------------------------------------------------------------

    // Fetch the current cart JSON
    function fetchCart() {
      return fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    }

    // Extract discount codes from the cart JSON
    //
    // Depending on theme/Shopify version, discount codes may show as:
    // - cart.cart_level_discount_applications (type: 'discount_code')
    // - or sometimes cart.discount_code / cart.discount_codes (older)
    //
    // We normalize to an array of { code, title }.
    function getDiscountCodesFromCart(cart) {
      const codes = [];

      // Newer style: cart_level_discount_applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          // Only include discount-code-based apps, skip automatic discounts
          if (app.type === 'discount_code' && app.code) {
            codes.push({
              code: app.code,
              title: app.title || app.code,
            });
          }
        });
      }

      // Older style: cart.discount_code (single) or cart.discount_codes (array)
      if (!codes.length && cart.discount_code) {
        codes.push({ code: cart.discount_code, title: cart.discount_code });
      }

      if (!codes.length && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach((dc) => {
          if (dc.code) {
            codes.push({ code: dc.code, title: dc.code });
          }
        });
      }

      return codes;
    }

    // Build the `discount` string for /cart/update.js from a list of codes
    // e.g. ['SAVE10','SHIPFREE'] -> 'SAVE10,SHIPFREE'
    function formatDiscountString(codes) {
      return codes.join(',');
    }

    // Render applied discount codes under the input
    function renderAppliedDiscounts(codes) {
      if (!codes.length) {
        appliedContainer.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'applied-discount-list';

      codes.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'applied-discount-item';

        const codeSpan = document.createElement('span');
        codeSpan.className = 'applied-discount-code';
        codeSpan.textContent = item.code;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'applied-discount-remove';
        removeBtn.setAttribute('aria-label', `Remove discount code ${item.code}`);
        removeBtn.textContent = '×'; // Remove icon

        removeBtn.addEventListener('click', () => {
          removeDiscountCode(item.code);
        });

        li.appendChild(codeSpan);
        li.appendChild(removeBtn);
        list.appendChild(li);
      });

      appliedContainer.innerHTML = '';
      appliedContainer.appendChild(list);
    }

    // Apply ALL discount codes to the cart via /cart/update.js
    function updateCartDiscounts(codes) {
      // check if the codes can not combine, return the applied codes that can be combined
      codes = codesCanNotCombineCheck(window.codesCanNotCombineArray, codes);

      const discountString = codes.length ? formatDiscountString(codes) : '';

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw data;
          });
        }
        return response.json();
      });
    }

    function showMessage(message, error = false) {
      messageEl.textContent = message;
      messageEl.classList.remove('hidden');
      if (error) {
        messageEl.classList.add('error');
      } else {
        messageEl.classList.remove('error');
      }
      setTimeout(() => {
        messageEl.classList.add('hidden');
        messageEl.classList.remove('error');
      }, 4000);
    }

    // Remove a single code from the list and update the cart
    function removeDiscountCode(codeToRemove, message, error = false) {
      form.classList.add('loading');
      fetchCart()
        .then((cart) => {
          const codes = getDiscountCodesFromCart(cart).map((c) => c.code);
          const remaining = codes.filter((c) => c !== codeToRemove);

          return updateCartDiscounts(remaining);
        })
        .then((updatedCart) => {
          showMessage(message || `${codeToRemove} removed.`, error);

          const currentCodes = getDiscountCodesFromCart(updatedCart).map((c) => c.code);
          renderAppliedDiscounts(getDiscountCodesFromCart(updatedCart));

          // Optionally: refresh totals / cart UI from updatedCart
          console.log('Updated cart after removing code:', codeToRemove);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // refresh cart
          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showMessage('Unable to remove discount. Please try again.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Init: fetch cart and render applied codes --------------------------

    async function init(loading = true) {
      fetchCart()
        .then((cart) => {
          // const codes = getDiscountCodesFromCart(cart);
          // renderAppliedDiscounts(codes);
          if (loading) {
            form.classList.add('loading');
          } else {
            form.classList.add('updating');
          }
          let AllCodes = cart.discount_codes;
          let appliedCodes = [];
          AllCodes.forEach((code) => {
            if (code.applicable) {
              appliedCodes.push(code.code);
            }
          });
          appliedCodesToStr = appliedCodes.join(',');
          let updates = {
            discount: appliedCodesToStr,
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log(data);
              const codes = getDiscountCodesFromCart(data);
              renderAppliedDiscounts(codes);
              console.log('Applied discount codes:', codes);

              // update discount summary
              const grouped = getGroupedDiscountsFromCart(data);
              renderDiscountSummary(summaryContainer, grouped);

              form.classList.remove('loading');
              form.classList.remove('updating');
            });
        })
        .catch((err) => {
          console.error('Error fetching cart:', err);
          form.classList.remove('loading');
          form.classList.remove('updating');
        });
    }

    window.addEventListener('refreshAjaxCart', () => init(true));

    // add newCode
    function addNewCode(newCode) {
      form.classList.add('loading');
      // Strategy:
      // 1. Fetch current cart & existing codes
      // 2. Add new code to the list (if not already present)
      // 3. POST all codes as a single string to cart/update.js
      fetchCart()
        .then((cart) => {
          const existingCodes = getDiscountCodesFromCart(cart).map((c) => c.code.toLowerCase());

          const mergedCodes = [...new Set([...existingCodes, newCode.toLowerCase()])];

          return updateCartDiscounts(mergedCodes);
        })
        .then((updatedCart) => {
          // check if the discount is applicable, if not, show the error message and remove this discount code
          let thisCode = updatedCart.discount_codes.find((code) => code.code.toLowerCase() === newCode.toLowerCase());
          if (thisCode && !thisCode.applicable) {
            console.log('Discount is not applicable:', thisCode);
            removeDiscountCode(thisCode.code.toLowerCase(), `${thisCode.code} is not applicable.`, true);
            input.value = '';
            return;
          }

          // showMessage('Discount applied.');

          input.value = '';

          const codes = getDiscountCodesFromCart(updatedCart);
          renderAppliedDiscounts(codes);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // Optionally: re-render cart totals, etc.
          console.log('Updated cart with discount(s):', codes);

          // refresh line item discount summary and cart

          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error applying discount:', error);
          showMessage('Unable to apply this discount.', true);
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // codes can not combine
    function codesCanNotCombineCheck(codesNotCombineArray, appliedCodes) {
      codesNotCombineArray = codesNotCombineArray || [];
      appliedCodes = appliedCodes || [];

      if (codesNotCombineArray.length === 0 || appliedCodes.length === 0) {
        return appliedCodes;
      }

      let finalCodesToRemove = [];
      // for each codes in codesNotCombineArray, check if it is in appliedCodes
      for (let i = 0; i < codesNotCombineArray.length; i++) {
        if (appliedCodes.includes(codesNotCombineArray[i])) {
          finalCodesToRemove.push(codesNotCombineArray[i]);
        }
      }

      if (finalCodesToRemove.length > 1) {
        for (let i = 0; i < finalCodesToRemove.length; i++) {
          if (i > 0) {
            appliedCodes.splice(appliedCodes.indexOf(finalCodesToRemove[i]), 1);
          }
        }

        // show message
        // showMessage(`${finalCodesToRemove.join(', ')} are not combineable together.`);
        console.log('Codes Can Not Combine:', finalCodesToRemove);
        console.log('Final Applied Codes:', appliedCodes);
      }
      return appliedCodes;
    }

    // --- Form submit: apply a discount code ---------------------------------

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const newCode = input.value.trim();
      if (!newCode) {
        // showMessage('Please enter a discount code.');
        return;
      }

      addNewCode(newCode);
    });

    // discount-summary -----------------------------------

    // Build a friendly label from a discount_application / cart_level_discount_application
    function getDiscountLabel(app) {
      // Prefer a human-readable title; fallback to code; fallback to type
      return app.title || app.code || app.type || 'Discount';
    }

    // Returns array of { label, totalAmount } where totalAmount is a number (in shop currency)
    function getGroupedDiscountsFromCart(cart) {
      const groups = Object.create(null); // { [label]: totalAmountNumber }

      // 1) Line-item level discounts
      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach((alloc) => {
            const app = alloc.discount_application || {};
            const label = getDiscountLabel(app);
            const amount = parseFloat(alloc.amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          });
        });
      }

      // 2) Cart-level discount applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          let thisApp = app.discount_application || app;
          // console.log('cart_level_discount_applications:', thisApp);
          if (thisApp.type === 'discount_code') {
            const label = getDiscountLabel(thisApp);
            const amount = parseFloat(thisApp.total_allocated_amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          }
        });
      }

      // Convert map → array
      return Object.keys(groups).map((label) => ({
        label,
        totalAmount: groups[label],
      }));
    }

    function formatMoneyFromNumber(amount) {
      // amount is a number in store currency (e.g. 5 -> $5.00)
      // Use Shopify's money formatting if needed; this simple example uses Intl
      // Adjust currency code and locale to your store.
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrentCurrency,
      }).format(amount);
    }

    function renderDiscountSummary(container, discounts) {
      if (!container) return;

      if (!discounts.length) {
        container.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'discount-summary-list';

      discounts.forEach((d) => {
        const li = document.createElement('li');
        li.className = 'discount-summary-item';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'discount-summary-name';
        nameSpan.innerHTML = `${window.shopDiscountLabelSvgHtml} ${d.label}`;

        const amountSpan = document.createElement('span');
        amountSpan.className = 'discount-summary-amount';
        // Show as negative amount
        amountSpan.textContent = '-' + formatMoneyFromNumber(d.totalAmount / 100.0);

        li.appendChild(nameSpan);
        li.appendChild(amountSpan);
        list.appendChild(li);
      });

      container.innerHTML = '';
      container.appendChild(list);
    }

    window.refreshAjaxCartDiscountSummary = () => {
      fetchCart()
        .then((cart) => {
          const grouped = getGroupedDiscountsFromCart(cart);
          renderDiscountSummary(summaryContainer, grouped);
        })
        .catch((err) => {
          console.error('Error fetching cart for discounts:', err);
        });
    };

    init();
    // window.refreshAjaxCartDiscountSummary();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-variants-swatch"] && !Shopify.designMode) return;
  try {
    window.AXXVariantsSwatch = class {
    // 选择器 [data-axx-swatch]
    // 父级 [data-product-swatch]
    // 图片 [data-product-swatch-images]
    // 价格容器 [data-product-swatch-price]
    // 价格值 [data-product-swatch-price-value]
    // 对比价格 [data-product-swatch-compare-price-value]
    // url [data-product-swatch-url]

    constructor() {
      this.products = [];
      // 存储事件处理函数
      this.eventListeners = new Map();
    }

    init() {
      this.products = document.querySelectorAll('[data-axx-swatch]');
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 创建事件处理函数
        const handler = (e) => this.handlerChange(product, form);
        // 存储事件处理函数
        this.eventListeners.set(form, handler);
        // 添加事件监听器
        form.addEventListener('change', handler);
      });
    }

    update() {
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 获取存储的事件处理函数
        const handler = this.eventListeners.get(form);
        if (handler) {
          // 移除事件监听器
          form.removeEventListener('change', handler);
          // 清理存储的引用
          this.eventListeners.delete(form);
        }
      });
      this.products = [];
      this.init();
    }

    handlerChange(product, form) {
      const fieldsets = Array.from(form.querySelectorAll('[data-form-input]'));
      let options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
      this.updateCurrentVariant(product, options);
    }

    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      const sortedArr1 = [...arr1].sort();
      const sortedArr2 = [...arr2].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          return false;
        }
      }
      return true;
    }

    getVariantData(product) {
      let variantData = JSON.parse(product.querySelector('[type="application/json"]').textContent);
      return variantData;
    }

    updateCurrentVariant(product, options) {
      let currentVariant = null;
      this.getVariantData(product).find((variant) => {
        // match the current variant
        if (this.areArraysEqual(variant.options, options)) {
          currentVariant = variant;
        }
      });
      // console.log(currentVariant.id);
      if (currentVariant) {
        this.setProductInfo(product, currentVariant);
        this.updateVariantStatuses(product, currentVariant);
      }
    }

    updateVariantStatuses(product, currentVariant) {
      let $this = this;
      let forms = product.querySelector('form').querySelectorAll('[data-form-input]');
      if (forms.length < 2) {
        return;
      }
      // Disable all inputs
      forms.forEach((form) => {
        form.querySelectorAll('input').forEach((input) => {
          input.classList.add('disabled');
        });
      });
      // Enable only the matched inputs
      forms.forEach((form, index) => {
        let checkedInput = form.querySelector(':checked');
        let matchedVariants = $this
          .getVariantData(product)
          .filter((variant) => variant.options[index] === checkedInput.value);
        // console.log(matchedVariants);
        matchedVariants.forEach((variant) => {
          let available = variant.available;
          variant.options.forEach((option, optionIndex) => {
            if (optionIndex !== index) {
              // console.log(option);
              let optionInputs = forms[optionIndex].querySelectorAll(`input[value="${option}"]`);
              optionInputs.forEach((input) => {
                if (available) {
                  input.classList.remove('disabled');
                }
              });
            }
          });
        });
      });
    }

    setProductInfo(product, variant) {
      let productId = product.dataset.productId;
      let productUrl = product.dataset.productUrl;
      let productUrlWithVariant = productUrl + '?variant=' + variant.id;
      let productInfo = {
        id: variant.id,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        image: variant.featured_image.src,
        image_id: variant.featured_image.id,
        url: productUrlWithVariant,
        options: variant.options,
        available: variant.available,
      };
      this.updateProductInfo(product, productId, productInfo);
      this.sendCustomEvent(product, productId, 'variant:change', productInfo);
      // console log
      console.log(`SwatchChanged:[product:${productId}],[variant:${variant.id}]`);
    }

    updateProductInfo(product, productId, productInfo) {
      // match the parent element '[data-product-swatch]'
      let parent = product.closest('[data-product-swatch]');
      // update product data info
      if (parent) {
        parent.dataset.productInfo = JSON.stringify(productInfo);
        // update images src and srcset
        let images = parent.querySelectorAll(`[data-product-swatch-images]`);
        if (images) {
          images.forEach((image) => {
            let imageInfo = JSON.parse(image.querySelector('[type="application/json"]').textContent);
            imageInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                image.querySelector('img').src = variant.image.src;
                image.querySelector('img').srcset = variant.image.srcset;
              }
            });
          });
        }
        // update price
        let priceWarpper = parent.querySelectorAll('[data-product-swatch-price]');
        if (priceWarpper) {
          priceWarpper.forEach((price) => {
            let the_price = price.querySelector('[data-product-swatch-price-value]');
            let the_compare_price = price.querySelector('[data-product-swatch-compare-price-value]');
            let priceInfo = JSON.parse(price.querySelector('[type="application/json"]').textContent);
            priceInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                the_price.textContent = variant.price;
                the_compare_price.textContent = variant.compare_at_price;
                if (variant.compare_at_price) {
                  the_compare_price.classList.remove('hidden');
                } else {
                  the_compare_price.classList.add('hidden');
                }
              }
            });
          });
        }
        // update url
        let urlWarpper = parent.querySelectorAll('[data-product-swatch-url]');
        if (urlWarpper) {
          urlWarpper.forEach((url) => {
            url.setAttribute('href', productInfo.url);
          });
        }
      }
    }

    sendCustomEvent(product, productId, eventName, detail) {
      let parent = product.closest('[data-product-swatch]');
      if (parent) {
        let event = new CustomEvent(eventName, { detail });
        parent.dispatchEvent(event);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.axxVariantsSwatch = new window.AXXVariantsSwatch();
    window.axxVariantsSwatch.init();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collapsible-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const collapsibleSections = document.querySelectorAll('.alp-collapsible-section');
    collapsibleSections.forEach((section) => {
      section.addEventListener('click', function () {
        if (this.classList.contains('active')) {
          this.classList.remove('active');
          gsap.to(this.querySelector('.alp-collapsible-section-content'), {
            height: 0,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        } else {
          this.classList.add('active');
          gsap.to(this.querySelector('.alp-collapsible-section-content'), {
            height: this.querySelector('.alp-collapsible-section-content').scrollHeight,
            duration: 0.3,
            ease: 'power2.inOut',
          });
        }
      });
      if (section.classList.contains('active')) {
        gsap.to(section.querySelector('.alp-collapsible-section-content'), {
          height: section.querySelector('.alp-collapsible-section-content').scrollHeight,
          duration: 0.3,
          ease: 'power2.inOut',
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-360-viewer-popup"] && !Shopify.designMode) return;
  try {
    class LX360Viewer extends HTMLElement {
    static TOTAL_STEPS = 720;

    constructor() {
      super();
      this._realIndex = 0;
      this._currentStep = 0;
      this._ratio = 1;
      this._onOpen = this.handleOpenClick.bind(this);
      this._onClose = this.handleClose.bind(this);
      this._onOutsideClick = this.handleOutsideClick.bind(this);
      this._onUpdateViewer = this.handleUpdateViewer.bind(this);
    }

    connectedCallback() {
      this.imageNumber = Number(this.dataset.imageNumber) || 0;
      this.defaultImage = Number(this.dataset.defaultImage) || 0;

      if (this.imageNumber <= 0) return;

      this.openBtn = this.querySelector('.lx-v360-viewer__open');
      this.overlay = this.querySelector('.lx-v360-viewer__overlay');
      this.stage = this.querySelector('.lx-v360-viewer__stage');
      this.tips = this.querySelector('.lx-v360-viewer__tips');
      this.frames = this.querySelectorAll('.lx-v360-viewer__frame');

      this._ratio = LX360Viewer.TOTAL_STEPS / this.imageNumber;
      this._realIndex = Math.min(this.defaultImage, this.frames.length - 1);
      this._currentStep = this._realIndex * this._ratio;

      this.overlay?.classList.add('lx-v360-viewer__overlay--hidden');

      this.openBtn?.addEventListener('click', this._onOpen);
      this.querySelector('.lx-v360-viewer__close')?.addEventListener('click', this._onClose);
      window.addEventListener('updateViewer', this._onUpdateViewer);

      this.setActiveFrame(this._realIndex);
      this.waitForObserverAndInit();
    }

    disconnectedCallback() {
      this.openBtn?.removeEventListener('click', this._onOpen);
      this.querySelector('.lx-v360-viewer__close')?.removeEventListener('click', this._onClose);
      window.removeEventListener('updateViewer', this._onUpdateViewer);
      this.unbindOutsideClick();
      this._observer?.kill();
      this._observer = null;
    }

    isOpen() {
      return this.overlay?.classList.contains('lx-v360-viewer__overlay--active') ?? false;
    }

    bindOutsideClick() {
      requestAnimationFrame(() => {
        document.addEventListener('click', this._onOutsideClick, true);
      });
    }

    unbindOutsideClick() {
      document.removeEventListener('click', this._onOutsideClick, true);
    }

    handleOpenClick(event) {
      event.stopPropagation();
      this.handleOpen();
    }

    handleOutsideClick(event) {
      if (!this.isOpen() || this.contains(event.target)) return;
      this.handleClose();
    }

    waitForObserverAndInit(attempt = 0) {
      const Observer = window.gsap?.Observer || window.Observer;
      if (Observer && this.stage) {
        window.gsap?.registerPlugin?.(Observer);
        this.initObserver(Observer);
        return;
      }
      if (attempt > 50) return;
      requestAnimationFrame(() => this.waitForObserverAndInit(attempt + 1));
    }

    initObserver(Observer) {
      this._observer = Observer.create({
        target: this.stage,
        type: 'touch,pointer',
        onDrag: (self) => this.updateStep(self.deltaX),
        onDragStart: () => {
          this.tips?.classList.add('lx-v360-viewer__tips--hidden');
          this.classList.add('lx-v360-viewer--dragging');
        },
        onDragEnd: () => {
          this.tips?.classList.remove('lx-v360-viewer__tips--hidden');
          this.classList.remove('lx-v360-viewer--dragging');
        },
      });
    }

    setActiveFrame(index) {
      this.frames.forEach((frame, i) => {
        frame.classList.toggle('lx-v360-viewer__frame--active', i === index);
      });
    }

    updateStep(deltaX) {
      this._currentStep = Math.round(this._currentStep + deltaX);

      if (this._currentStep < 0) {
        this._currentStep = LX360Viewer.TOTAL_STEPS;
      } else if (this._currentStep > LX360Viewer.TOTAL_STEPS) {
        this._currentStep = 0;
      }

      this._realIndex = Math.round(this._currentStep / this._ratio);
      this.setActiveFrame(this._realIndex);
    }

    handleUpdateViewer() {
      this.setActiveFrame(this._realIndex);
    }

    handleOpen() {
      if (!this.overlay) return;

      this.overlay.classList.remove('lx-v360-viewer__overlay--hidden');
      window.lazyLoadInstance?.update?.();

      requestAnimationFrame(() => {
        this.overlay.classList.add('lx-v360-viewer__overlay--active', 'lx-v360-viewer__overlay--loaded');
      });

      this.openBtn?.classList.add('lx-v360-viewer__open--hidden');
      this.bindOutsideClick();
    }

    handleClose() {
      if (!this.overlay) return;

      this.unbindOutsideClick();
      this.overlay.classList.remove('lx-v360-viewer__overlay--active');
      this.openBtn?.classList.remove('lx-v360-viewer__open--hidden');

      setTimeout(() => {
        this.overlay.classList.add('lx-v360-viewer__overlay--hidden');
        this.overlay.classList.remove('lx-v360-viewer__overlay--loaded');
      }, 600);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('lx-360-viewer')) {
      customElements.define('lx-360-viewer', LX360Viewer);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-buy-buttons"] && !Shopify.designMode) return;
  try {
    class LXSubmitButton extends HTMLElement {
    constructor() {
      super();
      this.handleSubmit = this.handleSubmit.bind(this);
      this.AdditionalProductsAddCart = this.AdditionalProductsAddCart.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('[data-lx-add-to-cart-button]');
      this.variantInput = this.querySelector('[name="id"]');

      if (!this.form || !this.button) return;

      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    getShopifyRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    setLoading(loading) {
      if (!this.button) return;

      this.button.classList.toggle('loading', loading);

      if (loading) {
        this.button.setAttribute('aria-disabled', 'true');
        this.button.disabled = true;
        return;
      }

      const variantAvailable = this.variantInput && !this.variantInput.disabled;
      this.button.disabled = !variantAvailable;
      if (variantAvailable) {
        this.button.removeAttribute('aria-disabled');
      } else {
        this.button.setAttribute('aria-disabled', 'true');
      }
    }

    AdditionalProductsAddCart() {
      const items = [];

      document.querySelectorAll('[data-addional-product].selected').forEach((el) => {
        const variantId = el.querySelector('select')?.value;
        if (variantId) items.push({ id: variantId });
      });
      document.querySelectorAll('[data-promotion-pack].selected').forEach((el) => {
        const variantId = el.getAttribute('data-pack-variant');
        if (variantId) items.push({ id: variantId });
      });
      document.querySelectorAll('[data-compatible-product].selected').forEach((el) => {
        const variantId = el.getAttribute('data-compatible-variant');
        if (variantId) items.push({ id: variantId });
      });

      return items;
    }

    getFormQuantity() {
      const quantityInput = this.form?.querySelector('lx-quantity-input [name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    getFormProperties() {
      if (!this.form) return {};

      const properties = {};
      const formData = new FormData(this.form);

      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') {
          properties[match[1]] = value;
        }
      }

      return properties;
    }

    buildCartItems(variantId, quantity) {
      const items = [
        {
          id: variantId,
          quantity,
          properties: this.getFormProperties(),
        },
      ];

      this.AdditionalProductsAddCart().forEach((item) => {
        items.push({
          id: item.id,
          quantity,
          properties: item.properties || {},
        });
      });

      return items;
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.form || !this.button || this.button.disabled) return;

      const variantId = this.variantInput?.value;
      if (!variantId || this.variantInput?.disabled) return;

      this.setLoading(true);
      this.form.classList.add('ajaxForm', 'loading');

      try {
        const quantity = this.getFormQuantity();
        const cartItems = this.buildCartItems(variantId, quantity);

        let response;
        if (typeof AlpFn !== 'undefined' && typeof AlpFn.AddToCartMulti === 'function') {
          response = await AlpFn.AddToCartMulti(cartItems);
        } else {
          const formData = new FormData(this.form);
          response = await fetch(`${this.getShopifyRoot()}cart/add.js`, {
            method: 'POST',
            body: formData,
          });
        }

        if (!response || response === false) {
          throw new Error('Add to cart failed');
        }

        const data = await response
          .clone()
          .json()
          .catch(() => ({}));

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (typeof AlpFn !== 'undefined' && typeof AlpFn.refreshCart === 'function') {
          await AlpFn.refreshCart('[data-ajax-cart]', response);
          document.body.classList.add('cart-open');
          const cartDrawer = document.querySelector('[data-ajax-cart]');
          setTimeout(() => {
            cartDrawer?.classList.add('open');
            document.body.classList.add('noscroll');
          }, 50);
        } else if (window.routes?.cart_url) {
          window.location = window.routes.cart_url;
        }

        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:success', {
            bubbles: true,
            detail: { variantId, cartItem: data },
          })
        );
      } catch (error) {
        console.error('[lx-submit-button]', error);
        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:error', {
            bubbles: true,
            detail: { message: error?.message || 'Add to cart failed' },
          })
        );
      } finally {
        this.form?.classList.remove('loading');
        this.setLoading(false);
        this.dispatchEvent(
          new CustomEvent('lx-add-to-cart:finished', {
            bubbles: true,
            detail: { message: 'Add to cart Finished' },
          })
        );
      }
    }
  }

  if (!customElements.get('lx-submit-button')) {
    customElements.define('lx-submit-button', LXSubmitButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-products-additional-products"] && !Shopify.designMode) return;
  try {
    class LXAdditionalProducts extends HTMLElement {
    constructor() {
      super();
      this._onChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this._onChange);
      this.syncAllSelectedStates();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
    }

    get isSingleSelect() {
      return this.dataset.singleSelect === 'true';
    }

    get items() {
      return this.querySelectorAll('.lx-additional-products__item');
    }

    syncSelectedState(item, checked) {
      item.classList.toggle('selected', checked);
    }

    syncAllSelectedStates() {
      this.items.forEach((item) => {
        const input = item.querySelector('.lx-additional-products__input');
        this.syncSelectedState(item, input?.checked ?? false);
      });
    }

    handleChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('lx-additional-products__input')) {
        return;
      }

      if (this.isSingleSelect) {
        this.items.forEach((item) => {
          const otherInput = item.querySelector('.lx-additional-products__input');
          this.syncSelectedState(item, otherInput?.checked ?? false);
        });
        return;
      }

      const item = input.closest('.lx-additional-products__item');
      if (item) {
        this.syncSelectedState(item, input.checked);
      }
    }
  }

  if (!customElements.get('lx-additional-products')) {
    customElements.define('lx-additional-products', LXAdditionalProducts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-quantity-input"] && !Shopify.designMode) return;
  try {
    class LxQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.field = this.querySelector('.lx-quantity-input__field');
      this.decreaseBtn = this.querySelector('[data-lx-qty-action="decrease"]');
      this.increaseBtn = this.querySelector('[data-lx-qty-action="increase"]');
      this.onFieldChange = this.onFieldChange.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
    }

    connectedCallback() {
      if (!this.field) return;

      this.field.addEventListener('change', this.onFieldChange);
      this.field.addEventListener('blur', this.onFieldChange);
      this.decreaseBtn?.addEventListener('click', this.onButtonClick);
      this.increaseBtn?.addEventListener('click', this.onButtonClick);

      this.syncValue();
      this.syncButtons();
    }

    disconnectedCallback() {
      this.field?.removeEventListener('change', this.onFieldChange);
      this.field?.removeEventListener('blur', this.onFieldChange);
      this.decreaseBtn?.removeEventListener('click', this.onButtonClick);
      this.increaseBtn?.removeEventListener('click', this.onButtonClick);
    }

    getRules() {
      const min = parseInt(this.field.dataset.lxQtyMin || this.field.min, 10) || 1;
      const step = parseInt(this.field.dataset.lxQtyStep || this.field.step, 10) || 1;
      const maxAttr = this.field.dataset.lxQtyMax || this.field.max;
      const max = maxAttr === '' || maxAttr == null ? null : parseInt(maxAttr, 10);
      return { min, step, max };
    }

    clampValue(rawValue) {
      const { min, step, max } = this.getRules();
      let value = parseInt(rawValue, 10);

      if (Number.isNaN(value)) value = min;

      if (value < min) value = min;

      if (max != null && value > max) value = max;

      const offset = (value - min) % step;
      if (offset !== 0) {
        value = value - offset;
        if (value < min) value = min;
      }

      return value;
    }

    syncValue() {
      this.field.value = String(this.clampValue(this.field.value));
    }

    syncButtons() {
      const { min, max } = this.getRules();
      const value = parseInt(this.field.value, 10);

      if (this.decreaseBtn) {
        this.decreaseBtn.disabled = value <= min;
      }

      if (this.increaseBtn) {
        this.increaseBtn.disabled = max != null && value >= max;
      }
    }

    onFieldChange() {
      this.syncValue();
      this.syncButtons();
    }

    onButtonClick(event) {
      event.preventDefault();
      const action = event.currentTarget?.dataset?.lxQtyAction;
      const { min, step, max } = this.getRules();
      let value = this.clampValue(this.field.value);

      if (action === 'increase') {
        value += step;
        if (max != null && value > max) value = max;
      } else {
        value -= step;
        if (value < min) value = min;
      }

      this.field.value = String(value);
      this.field.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncButtons();
    }
  }

  if (!customElements.get('lx-quantity-input')) {
    customElements.define('lx-quantity-input', LxQuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector-v1-zk"] && !Shopify.designMode) return;
  try {
    class LXVariantSelectorV1 extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant(true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const select = group.querySelector('select[data-option-select]');
        if (select) {
          const value = select.value;
          return value === '' ? null : value;
        }
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        const select = group.querySelector('select[data-option-select]');
        if (select) {
          Array.from(select.options).forEach((option) => {
            if (option.value === '') return;

            const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
              posIndex,
              option.value,
              selectedValues
            );

            let nativeDisabled = false;
            if (option.value !== select.value) {
              if (currentVariantNull) {
                nativeDisabled = true;
              } else if (allowDisableForSoldOut && !canPurchase) {
                nativeDisabled = true;
              }
            }

            option.disabled = nativeDisabled;
            option.hidden = currentVariantNull;
          });
          return;
        }

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        const select = group.querySelector('select[data-option-select]');
        if (select) {
          select.value = targetValue;
          return;
        }

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const select = this.querySelector(`select[data-option-select][name="option-${i}"]`);
        if (select) {
          select.value = val;
          continue;
        }

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
    }

    updateProductDetail(variant, available = true) {
      const productDetail = this.closest('[data-product-detail]');
      if (!productDetail) return;
      // update product variant id
      productDetail.dataset.variantId = available ? String(variant.id) : '';
      productDetail.dataset.available = available;
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
      // update product buy buttons without fetch, match element by [data-product-buy-buttons-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-buy-buttons-element]').forEach((element) => {
          let inputId = element.querySelector(`[name="id"]`);
          let submitButton = element.querySelector(`[type="submit"]`);
          if (inputId && submitButton) {
            inputId.value = String(variant.id);
            // set [name="id"] disabled
            inputId.disabled = !available;
            submitButton.disabled = !available;
            // set text with data-add-to-cart-text or data-sold-out-text
            submitButton.querySelector(`span`).textContent = available
              ? window.variantStrings.addToCart
              : window.variantStrings.soldOut;
          }
        });
      }
      // updata url use push state with custom parm
      const customParm = productDetail.dataset.customParm;
      let url = `${window.location.pathname}`;
      if (customParm) {
        url = `${url}?${variant ? `variant=${variant.id}&` : ''}${customParm}`;
        window.history.replaceState({ path: url }, '', url);
      } else {
        url = `${url}?${variant ? `variant=${variant.id}` : ''}`;
        window.history.replaceState({ path: url }, '', url);
      }
      // fetch product detail then dispatchEvent
      if (!variant) return;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.dispatchEvent(
            new CustomEvent('lx-variant-selector-v1:product-detail-updated', {
              bubbles: true,
              detail: { html, variant },
            })
          );
          // update product shipping time, match element by [data-product-shipping-time-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-shipping-time-element]');
          // update product properties, match element by [data-product-properties-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-properties-element]');
        });
    }

    replaceElementWrapper(currentEl, nextEl, selector) {
      const $currentEl = currentEl?.querySelectorAll(selector);
      const $nextEl = nextEl?.querySelectorAll(selector);
      if (!$currentEl || !$nextEl) return false;

      $currentEl.forEach((item, index) => {
        if (!$nextEl[index]) return;
        item.innerHTML = $nextEl[index].innerHTML;
      });
      return true;
    }

    updatePrice(variant, element) {
      const currency = Shopify.currency.active;
      const language = Shopify.locale + '-' + Shopify.country;
      if (variant.price) {
        const priceFormat = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-price]').textContent = priceFormat;
      }
      if (variant.compare_at_price) {
        const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        element.querySelector('[data-product-compare-price]').classList.remove('hidden');
      } else {
        element.querySelector('[data-product-compare-price]').classList.add('hidden');
      }
    }

    applyCurrentVariant(firstLoad = false) {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (!firstLoad) {
        const previousVariantId = this.dataset.productVariantId || '';
        const nextVariantId = variant ? String(variant.id) : '';
        if (previousVariantId === nextVariantId) {
          return variant;
        }
      }

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
        if (!firstLoad) {
          this.updateProductDetail(variant, variant.available);
        }
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
        if (!firstLoad) {
          this.updateProductDetail(variant, false);
        }
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');
      const isOptionSelect =
        target instanceof HTMLSelectElement && target.matches('select[data-option-select]');

      if (isOptionInput || isOptionSelect) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0 && target.value) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector-v1')) {
    customElements.define('lx-variant-selector-v1', LXVariantSelectorV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector-v1"] && !Shopify.designMode) return;
  try {
    class LXVariantSelectorV1 extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant(true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
    }

    updateProductDetail(variant, available = true) {
      const productDetail = this.closest('[data-product-detail]');
      if (!productDetail) return;
      // update product variant id
      productDetail.dataset.variantId = available ? String(variant.id) : '';
      productDetail.dataset.available = available;
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-price-element]').forEach((element) => {
          this.updatePrice(variant, element);
        });
      }
      // update product buy buttons without fetch, match element by [data-product-buy-buttons-element]
      if (variant) {
        productDetail.querySelectorAll('[data-product-buy-buttons-element]').forEach((element) => {
          let inputId = element.querySelector(`[name="id"]`);
          let submitButton = element.querySelector(`[type="submit"]`);
          if (inputId && submitButton) {
            inputId.value = String(variant.id);
            // set [name="id"] disabled
            inputId.disabled = !available;
            submitButton.disabled = !available;
            // set text with data-add-to-cart-text or data-sold-out-text
            submitButton.querySelector(`span`).textContent = available
              ? window.variantStrings.addToCart
              : window.variantStrings.soldOut;
          }
        });
      }
      // updata url use push state with custom parm
      const customParm = productDetail.dataset.customParm;
      let url = `${window.location.pathname}`;
      if (customParm) {
        url = `${url}?${variant ? `variant=${variant.id}&` : ''}${customParm}`;
        window.history.replaceState({ path: url }, '', url);
      } else {
        url = `${url}?${variant ? `variant=${variant.id}` : ''}`;
        window.history.replaceState({ path: url }, '', url);
      }
      // fetch product detail then dispatchEvent
      if (!variant) return;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.dispatchEvent(
            new CustomEvent('lx-variant-selector-v1:product-detail-updated', {
              bubbles: true,
              detail: { html, variant },
            })
          );
          // update product shipping time, match element by [data-product-shipping-time-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-shipping-time-element]');
          // update product properties, match element by [data-product-properties-element]
          this.replaceElementWrapper(productDetail, html, '[data-product-properties-element]');
        });
    }

    replaceElementWrapper(currentEl, nextEl, selector) {
      const $currentEl = currentEl?.querySelectorAll(selector);
      const $nextEl = nextEl?.querySelectorAll(selector);
      if (!$currentEl || !$nextEl) return false;

      $currentEl.forEach((item, index) => {
        if (!$nextEl[index]) return;
        item.innerHTML = $nextEl[index].innerHTML;
      });
      return true;
    }

    updatePrice(variant, element) {
      const currency = Shopify.currency.active;
      const language = Shopify.locale + '-' + Shopify.country;
      if (variant.price) {
        const priceFormat = (variant.price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-price]').textContent = priceFormat;
      }
      if (variant.compare_at_price) {
        const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString(language, {
          style: 'currency',
          currency: currency,
        });
        element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        element.querySelector('[data-product-compare-price]').classList.remove('hidden');
      } else {
        element.querySelector('[data-product-compare-price]').classList.add('hidden');
      }
    }

    applyCurrentVariant(firstLoad = false) {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (!firstLoad) {
        const previousVariantId = this.dataset.productVariantId || '';
        const nextVariantId = variant ? String(variant.id) : '';
        if (previousVariantId === nextVariantId) {
          return variant;
        }
      }

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
        if (!firstLoad) {
          this.updateProductDetail(variant, variant.available);
        }
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
        if (!firstLoad) {
          this.updateProductDetail(variant, false);
        }
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector-v1')) {
    customElements.define('lx-variant-selector-v1', LXVariantSelectorV1);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector"] && !Shopify.designMode) return;
  try {
    class LXVariantSelector extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          if (variant.price) {
            const priceFormat = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            element.querySelector('[data-product-price]').textContent = priceFormat;
          }
          if (variant.compare_at_price) {
            const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            });
            element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
          }
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            element.querySelector('[data-product-compare-price]').classList.remove('hidden');
          } else {
            element.querySelector('[data-product-compare-price]').classList.add('hidden');
          }
        });
      }
    }

    applyCurrentVariant() {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector')) {
    customElements.define('lx-variant-selector', LXVariantSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["z-additional-products-list-2"] && !Shopify.designMode) return;
  try {
    class ZAdditionalProducts extends HTMLElement {
    constructor() {
      super();
      this._onChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this._onChange);
      this.syncAllSelectedStates();
      this.list = this.querySelector('.z-additional-products__list');
      this.list?.addEventListener('touchstart', this.stopParentSwiper, { passive: true });
      this.list?.addEventListener('pointerdown', this.stopParentSwiper);
      this.list?.addEventListener('wheel', this.stopParentSwiper, { passive: true });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
      this.list?.removeEventListener('touchstart', this.stopParentSwiper);
      this.list?.removeEventListener('pointerdown', this.stopParentSwiper);
      this.list?.removeEventListener('wheel', this.stopParentSwiper);
    }

    stopParentSwiper(event) {
      event.stopPropagation();
    }

    get isSingleSelect() {
      return this.dataset.singleSelect === 'true';
    }

    get items() {
      return this.querySelectorAll('.z-additional-products__item');
    }

    syncSelectedState(item, checked) {
      item.classList.toggle('selected', checked);
    }

    syncAllSelectedStates() {
      this.items.forEach((item) => {
        const input = item.querySelector('.z-additional-products__input');
        this.syncSelectedState(item, input?.checked ?? false);
      });
    }

    handleChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('z-additional-products__input')) {
        return;
      }

      if (this.isSingleSelect) {
        this.items.forEach((item) => {
          const otherInput = item.querySelector('.z-additional-products__input');
          this.syncSelectedState(item, otherInput?.checked ?? false);
        });
        return;
      }

      const item = input.closest('.z-additional-products__item');
      if (item) {
        this.syncSelectedState(item, input.checked);
      }
    }
  }

  if (!customElements.get('z-additional-products')) {
    customElements.define('z-additional-products', ZAdditionalProducts);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["z-additional-products-list"] && !Shopify.designMode) return;
  try {
    class ZAdditionalProducts extends HTMLElement {
    constructor() {
      super();
      this._onChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', this._onChange);
      this.syncAllSelectedStates();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
    }

    get isSingleSelect() {
      return this.dataset.singleSelect === 'true';
    }

    get items() {
      return this.querySelectorAll('.z-additional-products__item');
    }

    syncSelectedState(item, checked) {
      item.classList.toggle('selected', checked);
    }

    syncAllSelectedStates() {
      this.items.forEach((item) => {
        const input = item.querySelector('.z-additional-products__input');
        this.syncSelectedState(item, input?.checked ?? false);
      });
    }

    handleChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.classList.contains('z-additional-products__input')) {
        return;
      }

      if (this.isSingleSelect) {
        this.items.forEach((item) => {
          const otherInput = item.querySelector('.z-additional-products__input');
          this.syncSelectedState(item, otherInput?.checked ?? false);
        });
        return;
      }

      const item = input.closest('.z-additional-products__item');
      if (item) {
        this.syncSelectedState(item, input.checked);
      }
    }
  }

  if (!customElements.get('z-additional-products')) {
    customElements.define('z-additional-products', ZAdditionalProducts);
  }
  } catch(e) { console.error(e); }
})();

})();
